import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from "@mui/material";

import { AppDeleteDialogProps } from "./types";

const AppDeleteDialog = ({
  open,
  loading = false,
  title = "Delete Confirmation",
  content,
  confirmText = "Delete",
  cancelText = "Cancel",
  onClose,
  onConfirm,
}: AppDeleteDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Stack
          direction="row"
          spacing={2}
          width="100%"
          justifyContent="flex-end"
        >
          <Button
            variant="outlined"
            disabled={loading}
            onClick={onClose}
          >
            {cancelText}
          </Button>

          <Button
            variant="contained"
            color="error"
            startIcon={
              loading ? (
                <CircularProgress
                  size={18}
                  color="inherit"
                />
              ) : (
                <DeleteOutlineOutlinedIcon />
              )
            }
            disabled={loading}
            onClick={onConfirm}
          >
            {loading ? "Deleting..." : confirmText}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default AppDeleteDialog;